import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AppState } from '@app/reducers';
import {
  CrudService, CustomDirectiveConfig,
  IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix,
  ResponseMessageTypes, RxjsService, SnackbarService,
  filterFormControlNamesWhichHasValues, formConfigs,
  prepareGetRequestHttpParams
} from '@app/shared';
import { LeadCreationStepperParamsCreateAction, SalesModuleApiSuffixModels, SearchDebterModel, ServiceAgreementStepsParams, selectLeadCreationStepperParamsState$ } from '@modules/sales';
import { Store, select } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { map } from 'rxjs/operators';
import { loggedInUserData } from '../../../../others/auth.selectors';
@Component({
  selector: 'app-search-service-modal',
  templateUrl: './search-service-debter.component.html',
  styleUrls: ['./service-installation-agreement.scss']
})
export class SearchServiceDebterComponent implements OnInit {
  searchDebterModel = new SearchDebterModel();
  searchServiceForm!: FormGroup
  numberConfig = new CustomDirectiveConfig({ isANumberOnly: true });
  banks = [];
  serviceAgreementStepsParams: ServiceAgreementStepsParams | any;
  formConfigs = formConfigs;
  isSearchBtnDisabled = true;
  debtorSearchModel;

  constructor(private crudService: CrudService,
    private store: Store<AppState>,
    private formBuilder: FormBuilder, private snackBarService: SnackbarService, public ref: DynamicDialogRef, public config: DynamicDialogConfig,
    private rxjsService: RxjsService) {
    this.debtorSearchModel = config?.data;
    this.store.select(selectLeadCreationStepperParamsState$).subscribe(res => {
      this.serviceAgreementStepsParams = new ServiceAgreementStepsParams(res);
    });
  }

  ngOnInit(): void {
    this.createSearchForm();
    this.getBanks();
    this.searchServiceForm.valueChanges
      .pipe(
        map((object) => filterFormControlNamesWhichHasValues(object)))
      .subscribe((keyValuesObj) => {
        this.isSearchBtnDisabled = (Object.keys(keyValuesObj).length == 0 || this.searchServiceForm.invalid) ? true : false;
      });
    this.store.pipe(select(loggedInUserData)).subscribe((userData: LoggedInUserModel) => {
      if (!userData) {
        this.dialogClose();
        return;
      };
    });
  }

  createSearchForm() {
    let searchDebterModel: any = new SearchDebterModel();
    this.searchServiceForm = this.formBuilder.group({
    });
    Object.keys(searchDebterModel).forEach((key) => {
      this.searchServiceForm.addControl(key, new FormControl(searchDebterModel[key]));
    });
  }

  getBanks() {
    this.crudService.get(ModulesBasedApiSuffix.BILLING, SalesModuleApiSuffixModels.SALES_API_BANKS, undefined, false)
      .subscribe((response: IApplicationResponse) => {
        if (response.resources && response.isSuccess && response.statusCode == 200) {
          this.banks = response.resources;
        }
        this.rxjsService.setPopupLoaderProperty(false);
      });
  }

  search() {
    if (this.searchServiceForm.invalid) {
      return;
    }
    const newParams = {
      ...this.serviceAgreementStepsParams, debtorSearchParams: { ...this.searchServiceForm.value },
    };
    this.store.dispatch(new LeadCreationStepperParamsCreateAction({serviceAgreementStepsParams: newParams}));
    let payload = this.searchServiceForm.value;
    payload['debtorTypeId'] = this.debtorSearchModel?.debtorTypeId;
    payload.quotationVersionId = this.serviceAgreementStepsParams.quotationVersionId;
    this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, SalesModuleApiSuffixModels.SALES_API_SEARCH_DEBTER, undefined, false,
      prepareGetRequestHttpParams(null, null, payload)).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          if (response.resources.length == 0) {
            this.snackBarService.openSnackbar("No Data Found", ResponseMessageTypes.SUCCESS);
          } else {
            this.ref.close(response.resources);
          }
        }
      });
  }

  dialogClose() {
    this.ref.close(false);
  }

  ngOnDestroy(): void {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
